var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import { ArticleCard, ButtonAsLink, LineGridLayout, breakpoint, styles as S } from '@bob/design-system';
import * as url from '@bob/url';
export function Similar(_ref) {
  var article = _ref.article;
  if (article.similar.length === 0) return __jsx(React.Fragment, null);
  return __jsx(Section, null, __jsx(S.heading.Title2, null, "Ces articles pourraient vous plaire..."), __jsx(S.heading.Title4, null, "Ces articles pourraient vous plaire..."), __jsx(LineGridLayout, null, article.similar.map(function (similar) {
    var _similar$firstPublish;

    return __jsx(ArticleCard, {
      key: similar.slug,
      href: url.article({
        slug: similar.slug,
        title: similar.title
      }).path,
      tag: similar.section,
      title: similar.title,
      date: new Date(similar.forceUpdatedAt ? similar.forceUpdatedAt : (_similar$firstPublish = similar.firstPublishedAt) !== null && _similar$firstPublish !== void 0 ? _similar$firstPublish : '').toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }),
      image: similar.image
    });
  })), __jsx(ButtonAsLink, {
    href: url.articles().path
  }, "Voir tous les articles"));
}
var Section = styled.section.withConfig({
  displayName: "Similar__Section",
  componentId: "sc-y2kaqd-0"
})(["margin-bottom:60px;", "{display:none;}@media screen and (", "){margin-bottom:80px;width:auto;display:flex;flex-direction:column;", "{display:inline-block;}", "{display:none;}}", "{margin-bottom:30px;margin-top:30px;}", "{width:100%;@media screen and (", "){width:auto;padding-left:10%;padding-right:10%;display:inline-flex;margin:0px auto;}}"], S.heading.Title2, breakpoint.TABLET, S.heading.Title2, S.heading.Title4, LineGridLayout, ButtonAsLink, breakpoint.TABLET);